import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
  isDeleting: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_MEMBER_TRANSACTION: {
      return {
        ...state,
        isCreating: true,
      };
    }
    case actions.CREATE_MEMBER_TRANSACTION_ENDED: {
      return {
        ...state,
        isCreating: false,
      };
    }
    case actions.SEARCH_MEMBER_TRANSACTIONS:
    case actions.FIND_MEMBER_TRANSACTION: {
      return {
        ...state,
        isSearching: true,
      };
    }
    case actions.SEARCH_MEMBER_TRANSACTIONS_ENDED:
    case actions.FIND_MEMBER_TRANSACTION_ENDED: {
      return {
        ...state,
        isSearching: false,
      };
    }
    default:
      return state;
  }
}
